import * as WpApi from 'wpapi';

const ApiService = WpApi({endpoint: window['Barker']['config']['restBaseUrl'], nonce: window['Barker']['config']['restNonce']});

ApiService.listings = ApiService.registerRoute( 
  'wp/v2', 
  '/barker_event_listing/(?P<id>)',
  {
    params: [ 'before', 'after', 'author', 'parent', 'post', 'page', 'perPage', 'status', 'barker_date_range' ]
  }
);

ApiService.movies = ApiService.registerRoute( 
  'wp/v2', 
  '/barker_movie/(?P<id>)',
  {
  }
);

ApiService.events = ApiService.registerRoute( 
  'wp/v2', 
  '/barker_event/(?P<id>)',
  {
  }
);

ApiService.searchEvent = ApiService.registerRoute(
  'barker/v1',
  '/search/(?P<s>)',
  {
    params: ['s', 'perPage', 'page'],
    mixins: {
      postType: function( val ) {
          return this.param( 'post_type', val );
      }
    }
  }
);

export { ApiService };


// WEBPACK FOOTER //
// ./resources/src/components/services/api-service.ts